import { gql } from '@apollo/client';

export const insertQuestionnaireMutation = gql`
  mutation ($object: questionnaires_insert_input!) {
    insert_questionnaires_one(object: $object) {
      id
    }
  }
`;
